import React, { useEffect, useMemo, useRef, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import { ILuxuryHome } from '@share/common-types';
import { useParams } from 'react-router-dom';
import { RootState } from '@share/utils';
import { Routes } from '@share/constants';

import { LuxuryHomesDetailsDescription } from './description';
import { LuxuryHomesDetailsNavigation } from './navigation';
import { LuxuryHomesDetailsActivities } from './activities';
import { LuxuryHomesDetailsAmenities } from './amenities';
import { LuxuryHomesDetailsActions } from './actions';
import { LuxuryHomesDetailsHeader } from './header';
import { LuxuryHomesDetailsLayout } from './layout';
import { LuxuryHomesDetailsMap } from './map';

import { getluxuryHomesDetailsRates, luxuryHomesDetailsActions } from '@store/slices';
import { LuxuryHomesDetailsImages } from '../commons/images';
import { LuxuryHomesMain } from '../commons/main/component';

import './style.scss';

const DEFAULT_ANCHOR = '0';

export const LuxuryHomesDetails: React.FC = () => {

  const descriptionRef = useRef<HTMLDivElement>(null);
  const highlightsRef = useRef<HTMLDivElement>(null);
  const amenitiesRef = useRef<HTMLDivElement>(null);
  const layoutRef = useRef<HTMLDivElement>(null);
  const mapRef = useRef<HTMLDivElement>(null);

  const dispatch = useDispatch();
  
  const [anchorSelected, setAnchorSelected] = useState(DEFAULT_ANCHOR);

  const { homes } = useSelector((state: RootState) => state.luxuryHomesStore);

  const { propertyId } = useParams<{ propertyId: string }>();
  const { roomId } = useParams<{ roomId: string }>();
  const { placeId } = useParams<{ placeId: string }>();
  const { listId } = useParams<{ listId: string }>();

  useEffect(() => {
    dispatch(luxuryHomesDetailsActions.setRates(null));
    dispatch(luxuryHomesDetailsActions.setUnavailableDates([]));
    dispatch(luxuryHomesDetailsActions.setError(''));
  },[]);

  useEffect(() => {
    if (propertyId) {
      dispatch(getluxuryHomesDetailsRates(parseInt(propertyId)));
    }
  }, [propertyId]);
  
  const home = useMemo(() => homes?.filter((home: ILuxuryHome) => home.id === parseInt(propertyId))?.[0], [homes, propertyId]);
  const route = listId ? Routes.LuxuryHomesList : placeId ? Routes.LuxuryHomesPlace : Routes.LuxuryHomes;

  return (
    <LuxuryHomesMain route={route} headerProps={{ fixed: true, className: 'luxury-homes-header__blue' }} className="luxury-homes-details">
      <LuxuryHomesDetailsImages home={home} />

      <div className="luxury-homes-details__container">

        <div className="luxury-homes-details__content">
          <LuxuryHomesDetailsHeader home={home} />

          <LuxuryHomesDetailsNavigation
            home={home}

            anchorSelected={anchorSelected}
            setAnchorSelected={setAnchorSelected}

            descriptionRef={descriptionRef}
            highlightsRef={highlightsRef}
            amenitiesRef={amenitiesRef}
            layoutRef={layoutRef}
            mapRef={mapRef}
          />

          <LuxuryHomesDetailsDescription home={home} descriptionRef={descriptionRef} />

          <LuxuryHomesDetailsActivities home={home} highlightsRef={highlightsRef} />

          <LuxuryHomesDetailsAmenities home={home} amenitiesRef={amenitiesRef} />

          <LuxuryHomesDetailsLayout home={home} layoutRef={layoutRef} />

          <LuxuryHomesDetailsMap home={home} mapRef={mapRef} />
        </div>

        <LuxuryHomesDetailsActions home={home} key={roomId} /> 
      </div>
    </LuxuryHomesMain>
  );
};
